import { Model, RailsFormat } from "./model"
import * as moment from "moment"
import { Contact } from "./contact"
import { ModifiedClass } from "./modified-class"
import { ClassBetween } from "./class-between"

export class Absence extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public contactId?: number,
    public startDateTime: Date = null,
    public endDateTime: Date = null,
    public classesBetween: ClassBetween[] = [],

    public contact: Contact = null,
    public modifiedClasses: ModifiedClass[] = [],

    public uiState: any = {},
  ) {
    super()
  }

  public static clone(obj: any) {
    const absence: Absence = new this()

    if (obj.id) { absence.id = obj.id }
    if (obj.contactId) { absence.contactId = obj.contactId }
    if (obj.startDateTime) { absence.startDateTime = obj.startDateTime }
    if (obj.endDateTime) { absence.endDateTime = obj.endDateTime }

    if (obj.classesBetween) { absence.classesBetween = obj.classesBetween }

    if (obj.contact) { absence.contact = Contact.clone(obj.contact) }


    if (obj.modifiedClasses && obj.modifiedClasses.length > 0) {
      obj.modifiedClasses.forEach((mc: any) => {
        absence.modifiedClasses.push(ModifiedClass.clone(mc))
      })
    }

    if (obj.uiState) { absence.uiState = obj.uiState }

    return absence
  }

  serializeForRails() {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }

    if (this.startDateTime) {
      response.startDateTime = moment(this.startDateTime).format("YYYY-MM-DD h:mm:ss a")
    }

    if (this.endDateTime) {
      response.endDateTime = moment(this.endDateTime).format("YYYY-MM-DD h:mm:ss a")
    }

    if (response.modifiedClasses) {
      response.modifiedClassesAttributes = response.modifiedClasses.map((m: any) => {
        return ModifiedClass.clone(m).serializeForRails()
      })
    }

    response.modifiedClasses = null
    response.contact = null
    response.uiState = null

    return response
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/absence.ts